import React, { Component } from "react";
import { connect } from 'react-redux';
import { currentWidget, setRegPage } from '../../../action/action';
import { setGoHome, setLoginRequired } from '../../action/homeAction';
import { sendAnalytics } from "../../../action/homeAction";
import SwipeableViews from 'react-swipeable-views';
import $ from 'jquery'
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { calculateTimeDifference, getDefaultAnalyticsLabel } from "../../JS/utility";
import { getSurvey, saveGuestRequest } from "../../../action/guestRequest";
import { closeOrderPopUp } from "../../action/hCommerce2";
import Loader from "../../UI/loader";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import GuestSelectDropdown from "../../UI/SelectDropdown";
import GuideCompContainer from "../autoCheckin/guideCompContainer";

// let startingX , startingY , movingX , movingY 

class HappyUnhappy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentQuestion: this.props.CheckedInGuest.length > 1 ? 1 : 2,
            startingX: null,
            movingX: null,
            feedbackSent: false,
            checkin: '',
            meals: '',
            service: '',
            facilities: '',
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.displayName,
            feedback: {},
            showLoader: false,
            showFailScreen: false,
            errorMessage: "",
            selectedGuest: {},
            showNameList: false,
            showTryAgain: false,
            getSurveyFailed: false
        }
    }

    touchStart = (evt) => {

        this.setState({
            startingX: evt.touches[0].clientX,
            startingY: evt.touches[0].clientY
        })

        // startingX = evt.touches[0].clientX ;
        // startingY = evt.touches[0].clientY ;
    }

    touchMove = (evt) => {

        this.setState({
            movingX: evt.touches[0].clientX,
            movingY: evt.touches[0].clientY
        })

        // movingX = evt.touches[0].clientX ;
        // movingY = evt.touches[0].clientY ;
    }

    touchEnd = () => {

        console.log("startingX, movingX", this.state.startingX, this.state.movingX)

        if (this.state.startingX + 100 < this.state.movingX) {
            let currentQuestion = this.state.currentQuestion
            if (currentQuestion > 1) {
                this.setState({ currentQuestion: currentQuestion - 1 })
            }
            console.log('right');
        } else if (this.state.startingX - 100 > this.state.movingX) {
            let currentQuestion = this.state.currentQuestion
            if (currentQuestion < this.props.survey.questions.length) {
                this.setState({ currentQuestion: currentQuestion + 1 })
            }
            console.log('left');
        }
    }

    goBack = () => {
        this.props.setGoHome(true);
    }

    componentWillUnmount() {
        this.props.currentWidget({});
        // $("#app-body").css("background","transparent");
        // Send Analytics
        if (this.props.guestIsLoggedIn) {
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second')
            let label = getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" })
            this.props.sendAnalytics(
                this.props.guestDetail,
                this.state.widgetName,
                EXIT,
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration },
                0,
                this.props.guestIsLoggedIn
            );
        }
        // 
    }

    getSurvey = () => {
        console.log("this.props.currentWidgets", this.props.currentWidgets)
        this.setState({ showLoader: true })
        if (this.props.currentWidgets.surveyId) {
            this.props.getSurvey(
                this.props.currentWidgets.surveyId,
                (status) => {
                    if (status) {
                        this.setState({ showLoader: false, getSurveyFailed: false })
                            if (this.props.survey.needsLogin){
                            if (!localStorage.getItem('room') || localStorage.getItem('room') === "null") {
                                if(process.env.REACT_APP_INROOMTAB == "true") {
                                    this.props.setLoginRequired(true)
                                } else {
                                    this.props.setRegPage(true);
                                }
                            }}
                    } else {
                        this.setState({
                            showLoader: false,
                            showFailScreen: true,
                            errorMessage: "Failed to get survey. Please try again",
                            showTryAgain: true,
                            getSurveyFailed: true
                        });
                    }
                })
        } else {
            this.setState({
                showLoader: false,
                showFailScreen: true,
                errorMessage: "No survey found",
                showTryAgain: false,
                getSurveyFailed: true
            })
        }
    }

    componentDidMount() {
        // this.props.currentWidget({widgetType: true});
        // $("#app-body").css("background","#fff");

        console.log('this.props.menuColor happy', this.props.menuColor)

        this.getSurvey()

        // Send Analytics
        if (this.props.guestIsLoggedIn) {
            let label = getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" })
            this.props.sendAnalytics(
                this.props.guestDetail,
                this.props.currentWidgets.displayName,
                CLICKED,
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                this.props.guestIsLoggedIn
            );
        }
        // 

    }

    sendFeedback = () => {
        if (Object.keys(this.state.feedback).length == this.props.survey.questions.length) {

            let selectedGuest
            if (this.props.CheckedInGuest.length == 1 || !this.props.guestIsLoggedIn) selectedGuest = this.props.CheckedInGuest[0]
            else {
                if (this.state.selectedGuest.guestToken)
                    selectedGuest = this.state.selectedGuest
                else {
                    this.props.closeOrderPopUp(true, "Please select the name")
                    return
                }
            }

            this.setState({ sendRequestInProg: true })
            this.props.saveGuestRequest(
                selectedGuest,
                localStorage.getItem("GuestJourneySessionToken"),
                Object.values(this.state.feedback),
                "",
                this.sendFeedbackCallback
            );
        }
    }

    sendFeedbackCallback = (status, msg) => {
        // this.props.closeOrderPopUp(true, "", msg, status);
        this.setState({ sendRequestInProg: false })
        if (status) {
            this.setState({ feedbackSent: true })
        } else {
            this.setState({ showFailScreen: true, errorMessage: msg })
        }
    }

    prevClick = () => {
        // console.log('prev click')
        let currentQuestion = this.state.currentQuestion
        if (currentQuestion > 1) {
            this.setState({ currentQuestion: currentQuestion - 1 })
        }
    }

    nextClick = () => {
        // console.log('next click')
        let currentQuestion = this.state.currentQuestion
        if (currentQuestion < this.props.survey.questions.length + 1) {
            this.setState({ currentQuestion: currentQuestion + 1 })
        }
    }

    onOptionClick = (questionObj, selectedOption) => {
        let currentQuestion = this.state.currentQuestion
        setTimeout(() => {
            if (this.props.CheckedInGuest.length == 0) {
                if (currentQuestion < this.props.survey.questions.length + 1) {
                    this.setState({ currentQuestion: currentQuestion + 1 })
                }
            }
            else {
                if (currentQuestion < this.props.survey.questions.length + 1) {
                    this.setState({ currentQuestion: currentQuestion + 1 })
                }
            }
        }, 500)

        let option = JSON.parse(selectedOption)

        this.setState({ feedback: { ...this.state.feedback, ...option } })
    }

    handleChange = (index) => {
        if ((this.props.CheckedInGuest.length == 1 || !this.props.guestIsLoggedIn) && index == 0) {
            this.setState({ currentQuestion: 0 })
            setTimeout(() => { this.setState({ currentQuestion: 2 }) }, 3)
            return
        }
        this.setState({ currentQuestion: index + 1 })

        /// the below code is not working but is for an enhancement 
        //  that user will be able to swipe to previous questions even if they didn't made any choice with current question
        // let oldIndex = this.state.currentQuestion - 1

        // if(!this.state.checkin && this.state.currentQuestion == 1){
        //     if(index > oldIndex){
        //         this.setState({currentQuestion: oldIndex + 1})            
        //     }
        // } else if(!this.state.meals && this.state.currentQuestion == 2){
        //     if(index > oldIndex){
        //         this.setState({currentQuestion: oldIndex + 1})            
        //     }
        // } else {
        //     this.setState({currentQuestion: index + 1})            
        // }
    }

    render() {
        return (
            <div id='happyOrUnhappy' class="main-container" style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat", backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>
                <header class="inner-pages w-footer subpages">
                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p class="bold">Guest feedback</p> */}
                    </div>
                </header>{console.log('this.state.currentQuestion', this.props.CheckedInGuest.length > 1, this.props.survey.questions)}

                {!this.state.feedbackSent ? <>
                <section class="widgets padding-0 margin-0 container-bg" style={{ height: '85vh' }}>

                    <div class="widget-header">
                        { this.props.currentWidgets.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgets.widgetHeaderImageUrl}`} alt={this.props.currentWidgets.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.currentWidgets.displayName}</div>
                    </div>


                    <div class="widgets">
                        <div class="form-window unboxed">
                            <div class="form-window-heading">
                                {this.props.survey.title}
                            </div>
                            <div class="carousel-pages"
                            // onTouchStart={event => this.touchStart(event)}
                            // onTouchMove={event => this.touchMove(event)}
                            // onTouchEnd={this.touchEnd}
                            >
                                <div class="carousel-container" style={{ width: '1045px' }}>

                                    <SwipeableViews
                                        index={this.state.currentQuestion - 1}
                                        disabled={this.props.survey.questions && Object.keys(this.state.feedback).length != this.props.survey.questions.length ? true : false}
                                        onChangeIndex={index => this.handleChange(index)}>
                                        {this.props.CheckedInGuest.length > 1 ? <div class="pages row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                            <div class="form-row margin-bottom-2">
                                                <label class="align-center" style={{ fontSize: '1.5rem' }}>Let's get started, can you tell me your name?</label>
                                                <div class="form-row" style={{ marginTop: '2em' }}>
                                                    <GuestSelectDropdown
                                                        selectedItem={this.state.selectedGuest.guestName}
                                                        listData={this.props.CheckedInGuest}
                                                        showList={this.state.showNameList}
                                                        setShowList={() => this.setState(prev => ({ showNameList: !prev.showNameList }))}
                                                        setSelectedItem={this.props.CheckedInGuest.length == 1 || !this.props.guestIsLoggedIn && this.state.currentQuestion == 1 ? () => this.setState({ currentQuestion: 2 }) : (obj) => {
                                                            this.setState(prev => ({ selectedGuest: obj, showNameList: !prev.showNameList }))
                                                            setTimeout(() => {
                                                                this.setState({ currentQuestion: 2 })
                                                            }, 500)
                                                        }}
                                                        selectKey="obj.guestName"
                                                    />
                                                </div>
                                            </div>
                                        </div> : <></>}
                                        {
                                            this.props.survey.questions && this.props.survey.questions.map((obj, index) => <div class="pages row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                                <div class="form-row margin-bottom-2">
                                                    <label class="align-center" style={{ fontSize: '1.5rem' }}>{obj.question}</label>
                                                    <div class="happyNot-container">
                                                        <label class="custom-radio icon-radio">
                                                            <input type="radio" class="happyNot" name={`${obj.type}${index}`} id="happyVal" onClick={() => {
                                                                this.setState({ service: 'H' })
                                                                this.onOptionClick(obj, `{"${obj.order}": ${obj.happyQualityPlusRequestId} }`)
                                                            }} style={this.state.service == 'H' ? { backgroundColor: this.props.menuColor.selectorColor } : {}} />
                                                            <span class="checkmark" >
                                                                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" viewBox="0 0 209.61 209.61"><defs><style>{`.ico-happy-cls-1 {fill: #ffce00;}.ico-happy-cls-1, .ico-happy-cls-2 {stroke: #000;stroke-miterlimit: 10;stroke-width: 10px;}.ico-happy-cls-2 {fill: none;}`}</style></defs><g id="Layer_1-2" data-name="Layer 1"><g><circle class="ico-happy-cls-1" cx="104.81" cy="104.81" r="99.81"/><path class="ico-happy-cls-2" d="M49.92,90.42s0-16.65,17.42-16.65,17.42,16.65,17.42,16.65"/><path class="ico-happy-cls-2" d="M124.39,90.42s0-16.65,17.42-16.65,17.42,16.65,17.42,16.65"/><path class="ico-happy-cls-2" d="M51.86,132.22s52.65,63.48,104.9,0"/></g></g></svg>
                                                            </span>
                                                        </label>
                                                        {obj.type == "happy-neutral-unhappy" && <label class="custom-radio icon-radio" >
                                                            <input type="radio" class="happyNot unhappy" name={`${obj.type}${index}`} id="Neutral" onClick={() => {
                                                                this.setState({ service: 'N' })
                                                                this.onOptionClick(obj, `{"${obj.order}": ${obj.neutralQualityPlusRequestId} }`)
                                                            }} />
                                                            <span class="checkmark">
                                                                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" viewBox="0 0 209.61 209.61"><defs><style>{`.ico-mid-cls-1 {fill: #000;stroke-width: 0px;}.ico-mid-cls-2 {fill: #ffce00;}.ico-mid-cls-2, .ico-mid-cls-3 {stroke: #000;stroke-miterlimit: 10;stroke-width: 10px;}.ico-mid-cls-3 {fill: none;}`}</style></defs><g id="Layer_1-2" data-name="Layer 1"><g><circle class="ico-mid-cls-2" cx="104.81" cy="104.81" r="99.81"/><circle class="ico-mid-cls-1" cx="68.39" cy="82.1" r="11.71"/><circle class="ico-mid-cls-1" cx="141.17" cy="82.1" r="11.71"/><line class="ico-mid-cls-3" x1="51.86" y1="142.19" x2="156.76" y2="142.19"/></g></g></svg>
                                                            </span>
                                                        </label>}
                                                        <label class="custom-radio icon-radio">
                                                            <input type="radio" class="happyNot unhappy" name={`${obj.type}${index}`} id="unhappyVal" onClick={() => {
                                                                this.setState({ service: 'UH' })
                                                                this.onOptionClick(obj, `{"${obj.order}": ${obj.unhappyQualityPlusRequestId} }`)
                                                            }} />
                                                            <span class="checkmark" >
                                                                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" viewBox="0 0 209.61 209.61"><defs><style>{`.ico-unhappy-cls-1 {fill: #000;stroke-width: 0px;}.ico-unhappy-cls-2 {fill: #ffce00;}.ico-unhappy-cls-2, .ico-unhappy-cls-3 {stroke: #000;stroke-miterlimit: 10;stroke-width: 10px;}.ico-unhappy-cls-3 {fill: none;}`}</style></defs><g id="Layer_1-2" data-name="Layer 1"><g><circle class="ico-unhappy-cls-2" cx="104.81" cy="104.81" r="99.81"/><path class="ico-unhappy-cls-3" d="M156.76,156.3s-52.65-63.48-104.9,0"/><circle class="ico-unhappy-cls-1" cx="68.39" cy="82.1" r="11.71"/><circle class="ico-unhappy-cls-1" cx="141.17" cy="82.1" r="11.71"/></g></g></svg>
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>)
                                        }
                                    </SwipeableViews>
                                    {/* } */}
                                </div>

                                <div class="multi-tips-pages">
                                    {this.props.survey.questions && this.props.survey.questions.map((item, index) => {
                                        return (
                                            <span className={`pages ${(this.state.currentQuestion - 2) == index && "current"}`} key={index}></span>
                                        );
                                    })}
                                </div>

                                <div class="carousel-nav">
                                    {((this.props.CheckedInGuest.length == 1 || !this.props.guestIsLoggedIn) && this.state.currentQuestion > 2) || (this.props.CheckedInGuest.length > 1 && this.state.currentQuestion != 1) ? <span class="nav-arrows prev" onClick={this.prevClick} ></span> : <></>}
                                    {this.state.currentQuestion < Object.keys(this.state.feedback).length + 1
                                        ? <span class="nav-arrows next" onClick={this.nextClick} ></span> : <></>}
                                </div>
                            </div>
                        </div>
                        {/* <div class="carousel-nav" style={{top: '18rem'}} > -> This part was for testing purpose can be removed if everything okay, the issue was with the click listener fo the span
                            {this.state.currentQuestion != 1 ? <span class="nav-arrows prev" onClick={this.prevClick} style={{left: '1rem'}}></span> : <></>}
                            {this.state.currentQuestion != 3 ? <span class="nav-arrows next" onClick={this.nextClick} style={{right: '1rem'}} ></span> : <></> }
                        </div> */}

                    </div>
                </section>
                <footer class="button-controls">
                    {this.state.currentQuestion > 1 && <div class="form-row form-pages" style={{ top: '-5rem' }}>
                        {this.state.currentQuestion - 1} of {this.props.survey.questions && this.props.survey.questions.length}
                    </div>}
                    <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <button style={{ color: this.props.menuColor.selectorColor, backgroundColor: this.props.menuColor.backgroundColor }} class={`primary w-100 all-caps ${this.props.survey.questions && Object.keys(this.state.feedback).length != this.props.survey.questions.length ? 'disabled' : ''}`} onClick={this.sendFeedback}>Finish</button>
                    </section>
                </footer>
                </>
                : <>
                    <section class="widgets padding-0 margin-0 container-bg" style={{ height: '100vh' }}>
                        <div class="multi-tips gallery-alt">
                            <div class="multi-tips-main">
                            <GuideCompContainer
                                image={`${CMSPath}${this.props.currentWidgets.widgetHeaderImageUrl}`}
                                heading="Thank you!"
                                text={this.props.survey.thanksText}
                                />
                            </div>
                        </div>
                        <div class="multi-tips-controls">
                            <button class="button primary" onClick={this.goBack}>Done</button>
                        </div>
                    </section>
                </>}

                {this.state.showFailScreen && <SuccessFailScreen tryAgain={this.getSurvey} statusMessage1={this.state.errorMessage || "Failed to send feedback"} close={() => this.state.getSurveyFailed ? this.goBack() : this.setState({ showFailScreen: false })} showClose={true} showTryAgain={this.state.showTryAgain} />}
                {(this.state.sendRequestInProg || this.state.showLoader) && <Loader close={() => this.setState({ sendRequestInProg: false })} displayMsg={this.state.sendRequestInProg ? "Sending data" : null} />}
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        serviceUnavailable: state.store2.serviceUnavailable,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        survey: state.store.survey,
        currentHomePage: state.store2.currentHomePage,
        CheckedInGuest: state.store.CheckedInGuest,
    }
}

export default connect(mapStateToProps, {
    currentWidget,
    setGoHome,
    setLoginRequired,
    sendAnalytics,
    getSurvey,
    saveGuestRequest,
    closeOrderPopUp,
    setRegPage
})(HappyUnhappy);